import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { OnboardingFlowHandlerActions, selectKycAppState } from '@redux';
import { KycComplete } from '@applicationKYC/Components/KycComplete';
import { Link } from 'react-router-dom';
import { Result } from 'antd';
import { storageHandler } from '@storageHandler';
import { ClockCircleOutlined } from '@ant-design/icons';
import { WelcomeContainerCardPaper } from '@/PageParts/PartContent/PartContent.styles';
import { redirectToSmeGO } from '@/PageParts';

export const APPLICATION_STATUSES = {
  ONBOARDING_COMPLETE: 'OnboardingComplete',
  PENDING: 'Pending'
};

export const INFO_ICON_COLORS = {
  bank: '#6B1FA2',
  smego: '#1f40a2'
};

export const StatusPages = () => {
  const { t } = useTranslation();
  const applicationState = useSelector(selectKycAppState);
  const [status, setStatus] = useState('Pending');
  const dispatch = useDispatch();
  const isBank = process.env.REACT_APP_TRADEMARK.includes('Bank');

  const email = process.env.REACT_APP_REJECTED_STATE_EMAIL;
  const phone = process.env.REACT_APP_REJECTED_STATE_PHONE;
  const infoIconColor = isBank ? INFO_ICON_COLORS.bank : INFO_ICON_COLORS.smego;

  useEffect(() => {
    if (!applicationState) {
      const company = storageHandler.getSessionStorage('company');
      dispatch(OnboardingFlowHandlerActions.handleOnboardingFlow(company));
    }

    setStatus(applicationState?.status);
  }, [applicationState]);

  useEffect(() => {
    const isSmeGoSession = storageHandler.getSessionStorage('smeGoSession');
    if (
      isSmeGoSession &&
      [APPLICATION_STATUSES.ONBOARDING_COMPLETE, APPLICATION_STATUSES.PENDING].includes(status)
    ) {
      const timeout = setTimeout(() => {
        redirectToSmeGO('', applicationState);
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [status]);

  const renderPendingStatus = () => (
    <Result
      title={t('status_page_info_title')}
      icon={<ClockCircleOutlined style={{ color: infoIconColor }} />}
      subTitle={
        <>
          <p>{t('status_page_info_message')}</p>
          <p>{t('status_page_info_sub_message')}</p>
        </>
      }
    />
  );

  const renderRejectedStatus = () => (
    <Result
      extra={
        <Trans
          t={t}
          i18nKey="rejected_state_text"
          values={{ email, phone }}
          components={{
            emailLink: <a href={`mailto:${email}`} />,
            phoneLink: <a href={`tel:${phone}`} />,
            smeLink: <Link />
          }}
        ></Trans>
      }
    />
  );

  const renderContactInfo = () => (
    <Result
      style={{ paddingTop: 0 }}
      icon={<></>}
      subTitle={
        <span>
          {t('status_page_info_mail')}: <a href={`mailto:${email}`}>{email}</a>
        </span>
      }
    />
  );

  return (
    <div>
      <WelcomeContainerCardPaper style={{ marginBottom: 0, paddingBottom: 0 }}>
        {status === 'Pending' && renderPendingStatus()}
        {applicationState?.state === 'RejectedByAmlOfficer' && renderRejectedStatus()}
        {applicationState?.state === 'OnboardingComplete' && (
          <KycComplete translation="onboarding_complete" />
        )}
      </WelcomeContainerCardPaper>

      {renderContactInfo()}
    </div>
  );
};
